export default "__VITE_PUBLIC_ASSET__c18d2092__"